export const FLAG_ERROR_MESSAGES = {
	PAGE_PERMISSIONS: 'Insufficient page permissions: You are not allowed to perform that action.',
	SPACE_PERMSSIONS:
		'Insufficient destination space permissions: You are not allowed to perform that action.',
	DELETED_PAGE: 'Source page is in trash',
	DELETED_PAGE_ALT: 'Source page not found',
	SPACE_NOT_FOUND: 'Destination Space not found',
	ARCHIVED_PAGE: 'Source page is archived, cannot be copied',
};
